<template>
    <div id="authentication" class="authentication relative" :class="{xl:$vuetify.breakpoint.xl}">
        <div v-if="$vuetify.breakpoint.smAndUp">
            <div class="background-auth"></div>
            <img class="absolute decor-one" width="18%" src="./../../assets/images/auth/Vector 37.png" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <img class="absolute decor-two" width="21%" src="./../../assets/images/auth/Vector 39.png" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <img class="absolute decor-three" width="22%" src="./../../assets/images/auth/Vector 38.png" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <div class="footer" :class="{md:$vuetify.breakpoint.md}">
                <img class="absolute decor-four" width="62%" height="466px" src="./../../assets/images/auth/Vector 40.png" :class="{xl:$vuetify.breakpoint.xl, lg:$vuetify.breakpoint.lg, mdAndSm:$vuetify.breakpoint.mdAndDown}">
                <img class="absolute decor-five" width="51%" height="203px" src="./../../assets/images/auth/Vector 36.png" :class="{xl:$vuetify.breakpoint.xl, lg:$vuetify.breakpoint.lg, mdAndSm:$vuetify.breakpoint.mdAndDown}">
                <img class="absolute decor-six" height="137px" src="./../../assets/images/auth/Group.png" :class="{xl:$vuetify.breakpoint.xl, lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
                <img class="absolute decor-seven" src="./../../assets/images/auth/Rectangle 627.png" v-if="$vuetify.breakpoint.mdAndUp"> 
                <div class="absolute decor-eight flex-center roboto-normal-14 clr-black-5f pointer" v-if="$vuetify.breakpoint.lgAndUp" :class="{xl:$vuetify.breakpoint.xl, lg:$vuetify.breakpoint.lg,}">
                    <!-- <div class="block-small">О Проекте</div>
                    <div class="block-small">FAQ</div> -->
                    <div class="block-big px-10" @click="toDataPolitic()">Документы, определяющие политику в отношении обработки персональных данных </div>
                    <div class="block-big px-10" @click="toPersonalAgreement()">Согласие на обработку персональных данных, собираемых на сайте</div>
                    <div class="block-big px-6" @click="toUserAgreement()">Пользовательское соглашение</div>
                    <div class="block-big pr-12" @click="toLicense()">Лицензионное соглашение</div>
                </div>
                <div class="absolute decor-eight-tablet roboto-normal-14 clr-black-5f pointer" :class="{mdAndSm:$vuetify.breakpoint.mdAndDown}" v-else>
                    <!-- <div class="mt-1">О Проекте</div>
                    <div class="mt-1">FAQ</div> -->
                    <div class="mt-1" @click="toDataPolitic()">Документы, определяющие политику в отношении обработки персональных данных </div>
                    <div  class="mt-1" @click="toPersonalAgreement()">Согласие на обработку персональных данных, собираемых на сайте</div>
                    <div class="mt-1" @click="toUserAgreement()">Пользовательское соглашение</div>
                    <div class="mt-1" @click="toLicense()">Лицензионное соглашение</div>
                </div>
            </div>
        </div>
        <Register v-if="$route.path == '/register'"/>
        <Login v-if="$route.path == '/login'"/>
    </div>
</template>

<script>
import Register from './Register'
import Login from './Login'
export default {
    name: 'Auth',
    components: {
        Register,
        Login
    }, 
    data() {
        return {
            localHost: window.location.origin
        }
    },
    methods: {
        toDataPolitic() {
            window.location=`${this.localHost}/terms/data_politic_en.html`
        },
        toPersonalAgreement() {
            window.location=`${this.localHost}/terms/personal_agreement_en.html`
        },
        toUserAgreement() {
            window.location=`${this.localHost}/terms/user_agreement_en.html`
        },
        toLicense() {
            window.location=`${this.localHost}/terms/license_en.html`
        }
    }
}
</script>

<style lang="scss" scoped>
#authentication, .authentication {
    &.xl {
        height:100vh;
    }
    .background-auth {
        min-height: 100%;
        min-width: 1024px;
        width:100%;
        height: auto;
        position: fixed;
        top: 0;
        left: 0;
        background:#F8F8F8;
    }
    .decor-one {
        top:117px;
        left:9%;
        &.lg {
           left:5%; 
        }
        &.md {
            left:1%; 
        }
        &.sm {
           left:1%;
           width:15%; 
        }
    }
    .decor-two {
        top:399px;
        left:14%;
        &.lg {
           left:10%; 
        }
        &.md {
            left:5%; 
        }
        &.sm {
           left:4%;
           width:11%; 
        }
    }
    .decor-three {
        top:305px;
        right:10%;
        &.lg {
            right:6%;
        }
        &.md {
            right:1%;
        }
        &.sm {
           right:1%;
           width:11%; 
        }
    }
    .decor-four {
        &.xl {
            bottom:0%;
        }
        &.lg {
            top:750px; 
        }
        &.mdAndSm {
            top:714px;
            height:366px;
        }
    }
    .decor-five {
        &.xl {
            bottom:0%;
            right:0%;
        }
        &.lg {
            top:1013px;
            right:0%;
        }
        &.mdAndSm {
            top:877px;
            right:0%;
        }
    }
    .decor-six {
        &.xl {
            right:7%;
            bottom:15%
        }
        &.lg {
            top:920px;
            right:7%;
        }
        &.md {
            top:772px;
            right:7%;
        }
        &.sm {
            top:772px;
            height:60px;
            right:2%;
        }
    }
    .decor-seven {
        bottom:0%;
        right:0%;
    }
    .decor-eight {
        &.xl {
            bottom:4%;
            margin-left:10%;
        }
        &.lg {
            top:1100px;
            margin-left:10%;
        }
        width:90%;
        opacity: 0.7;
        .block-small {
            width:10%;
        }
        .block-big {
            width:20%;
        }
    }
    .decor-eight-tablet {
        &.mdAndSm {
            top:900px;
            left:5%;
        }
    }
} 
</style>